<template>
  <div class="main-content">
    <div class="row">
      <div class="col-md-12">
        <div class="card">
          <div class="card-body">
            <form action="" @submit="requestAnalitics">
              <div>
                <h5>Рейтинг менеджеров</h5>
                <div class="flex date_selector_div">
                  <div class="mr-1 rangePicker">
                    <div>
                      <date-range-picker
                        ref="picker"
                        :startDate="startDate"
                        opens="right"
                        :ranges="ranges"
                        :locale-data="date_locale"
                        v-model="dateRange"
                      >
                      </date-range-picker>
                    </div>
                    <div class="pt-1">
                      <LoadingButton
                        title="Статистика"
                        :loading="loading"
                        type="button"
                        class="btn btn-info"
                        :color="$constants.PRIMARY_COLOR"
                        :onClick="() => managersStats()"
                      />
                    </div>
                  </div>
                  <div class="flex-grow-1">
                    <div class="flex">
                      <multiselect
                        class="mr-1"
                        v-model="selected_projects"
                        :options="allProjects"
                        :multiple="true"
                        label="name"
                        track-by="name"
                        placeholder="Выберите проект"
                        select-label="Выбрать"
                        deselect-label="Убрать проект">
                      </multiselect>
                      <multiselect
                        v-model="selected_agent"
                        :options="AgentsOptions"
                        :multiple="false"
                        label="name"
                        track-by="name"
                        placeholder="Выберите менеджера"
                        select-label="Выбрать"
                        deselect-label="Убрать менеджера">
                      </multiselect>
                    </div>
                    <div class="pt-1">
                      <button type="submit" class="btn btn-outline-info">Показать статистику менеджера</button>
                    </div>
                  </div>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>

    <div>
      <pulse-loader :loading="loading" :color="color" style="text-align: center"/>
    </div>

    <div v-if="!loading && managersStat" class="card">
      <div class="card-body">
        <div class="alert alert-info">
          <p>
            <span>Закрыто: <strong>{{ totalStat.closed.total }}</strong> ({{ totalStat.closed.percent }}%)</span>
            <span>Отмена М: <strong>{{ totalStat.rejected_m.total }}</strong> ({{
                totalStat.rejected_m.percent
              }}%)</span>
            <span>Отмена К: <strong>{{ totalStat.rejected_r.total }}</strong> ({{
                totalStat.rejected_r.percent
              }}%)</span>
          </p>
        </div>

        <table class="table mt-1 table-sm table-hover">
          <thead>
          <tr>
            <th></th>
            <th>Менеджер</th>
            <th class="block_1">Закрыто</th>
            <th class="block_1">Сумма</th>
            <th class="block_1">Чек</th>
            <th class="block_1">%</th>
            <th class="block_2">Отмена М</th>
            <th class="block_2">Сумма</th>
            <th class="block_2">%</th>
            <th class="block_3">Отмена К</th>
            <th class="block_3">Сумма</th>
            <th class="block_3">%</th>
            <th class="">Чек</th>
          </tr>
          </thead>
          <tbody>
          <tr v-for="(u, i) in getSorted(engadgedUsers, 'name')">
            <td>{{ i + 1 }}</td>
            <td>({{ u.id || 'без ID' }}) {{ u.name || 'не указан' }}</td>
            <template>
              <td class="block_1">{{ managersStat[u.id].closed.orders }}</td>
              <td class="block_1">{{ managersStat[u.id].closed.sum.toLocaleString('ru-RU') }}</td>
              <td class="block_1">{{ managersStat[u.id].closed.bill.toLocaleString('ru-RU') }}</td>
              <td class="block_1">{{ managersStat[u.id].closed.percent }}</td>
            </template>
            <template>
              <td class="block_2">{{ managersStat[u.id].rejected_m.orders }}</td>
              <td class="block_2">{{ managersStat[u.id].rejected_m.sum.toLocaleString('ru-RU') }}</td>
              <td class="block_2">{{ managersStat[u.id].rejected_m.percent }}</td>
            </template>
            <template>
              <td class="block_3">{{ managersStat[u.id].rejected_r.orders }}</td>
              <td class="block_3">{{ managersStat[u.id].rejected_r.sum.toLocaleString('ru-RU') }}</td>
              <td class="block_3">{{ managersStat[u.id].rejected_r.percent }}</td>
            </template>
            <td>{{ managersStat[u.id].total.bill.toLocaleString('ru-RU') }}</td>
          </tr>
          </tbody>
        </table>
      </div>
    </div>

    <div v-if="!loading && statData">
      <div class="card">
        <div class="card-body">
          <div class="row">
            <div class="col-md-3">
              <p>Всего поступило: <strong>{{ totalStatData.site.totalOrders }}</strong></p>
              <p>Обработано: <strong>{{ totalStatData.site.released }}
                ({{ Math.round(totalStatData.site.released * 100 / totalStatData.site.totalOrders) }}%)</strong></p>
              <p>Отменено: <strong>{{ totalStatData.site.rejected }}
                ({{ Math.round(totalStatData.site.rejected * 100 / totalStatData.site.totalOrders) }}%)</strong></p>
              <p>Не обработано:
                <strong>{{ totalStatData.site.totalOrders - totalStatData.site.released - totalStatData.site.rejected }}
                  ({{
                    Math.round((totalStatData.site.totalOrders - totalStatData.site.released - totalStatData.site.rejected) * 100 / totalStatData.site.totalOrders)
                  }}%)</strong></p>
              <p>Средний чек: <strong>{{
                  Math.round(statData.site_income_bill / totalStatData.site.released).toLocaleString('ru-RU')
                }}</strong></p>
            </div>
            <div class="col-md-9">
              <highcharts :options="siteOrderChartData"></highcharts>
            </div>
          </div>
        </div>
      </div>
      <div class="card">
        <div class="card-body">
          <div class="row">
            <div class="col-md-3">
              <!--              <p>Входящих звонков: <strong>{{ totalStatData.manual.phoneCalls }}</strong></p>-->
              <p>Всего создано: <strong>{{ totalStatData.manual.totalOrders }}</strong></p>
              <p>Обработано: <strong>{{ totalStatData.manual.released }}
                ({{ Math.round(totalStatData.manual.released * 100 / totalStatData.manual.totalOrders) }}%)</strong></p>
              <p>Отменено: <strong>{{ totalStatData.manual.rejected }}
                ({{ Math.round(totalStatData.manual.rejected * 100 / totalStatData.manual.totalOrders) }}%)</strong></p>
              <p>Не обработано: <strong>{{
                  totalStatData.manual.totalOrders - totalStatData.manual.released - totalStatData.manual.rejected
                }}
                ({{
                  Math.round((totalStatData.manual.totalOrders - totalStatData.manual.released - totalStatData.manual.rejected) * 100 / totalStatData.site.totalOrders)
                }}%)</strong></p>
              <p>Средний чек: <strong>{{
                  Math.round(statData.manual_bill / totalStatData.manual.released).toLocaleString('ru-RU')
                }}</strong></p>
            </div>
            <div class="col-md-9">
              <highcharts :options="manualOrderChartData"></highcharts>
            </div>
          </div>
        </div>
      </div>
      <div class="card">
        <div class="card-body">
          <div class="row">
            <div class="col-md-3">
              <p>Обработано: <strong>{{ totalStatData.manual.released + totalStatData.site.released }}</strong></p>
              <p>Всего отказов: <strong>{{ totalStatData.rejected_by_runner }} ({{
                  Math.round(totalStatData.rejected_by_runner * 100 / (totalStatData.manual.released + totalStatData.site.released))
                }}%)</strong></p>
            </div>
            <div class="col-md-9">
              <highcharts :options="rejectedByRunners"></highcharts>
            </div>
          </div>
        </div>
      </div>
      <div class="card" v-if="false && Object.keys(orders).length">
        <div class="card-body">
          <div class="row">
            <div class="col-md-6">
              <table class="table table-hover">
                <thead>
                <tr>
                  <th>Дата</th>
                  <th>Ручные</th>
                  <th>Сайт</th>
                  <th>Итого</th>
                </tr>
                </thead>
                <tbody v-for="(data, index) in list_of_agents" :key="data.value">
                <tr>
                  <td colspan="5">
                    {{ data.name }}
                  </td>
                </tr>
                <tr v-for="(o, date_str) in orders[data.value]">
                  <td>{{ date_str }} ({{ o.day }})</td>
                  <td>{{ o[9999] }}</td>
                  <td>{{ o[0] }}</td>
                </tr>
                <tr class="total_line">
                  <td>
                    {{ data.name }}
                  </td>
                  <td>{{ countTotal(orders[data.value], 9999) }}</td>
                  <td>{{ countTotal(orders[data.value], 0) }}</td>
                  <td>{{ countTotal(orders[data.value]) }}</td>
                </tr>
                </tbody>
              </table>
            </div>
            <div class="col-md-6">
              <table class="table table-hover">
                <thead>
                <tr>
                  <th>Дата</th>
                  <th>Ручные</th>
                  <th>Сайт</th>
                  <th>Итого</th>
                </tr>
                </thead>
                <tbody v-for="(data, index) in list_of_agents" :key="data.value">
                <tr>
                  <td colspan="5">
                    {{ data.name }}
                  </td>
                </tr>
                <tr v-for="(o, date_str) in orders_summ[data.value]">
                  <td>{{ date_str }} ({{ orders[data.value][date_str].day }})</td>
                  <td>{{ o[9999] }}</td>
                  <td>{{ o[0] }}</td>
                </tr>
                <tr class="total_line">
                  <td>
                    {{ data.name }}
                  </td>
                  <td>{{ countTotal(orders_summ[data.value], 9999) }}</td>
                  <td>{{ countTotal(orders_summ[data.value], 0) }}</td>
                  <td>{{ countTotal(orders_summ[data.value]) }}</td>
                </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped>
.pt-10 {
  padding-top: 10px;
}

table td {
  padding: 1px;
}

table .total_line {
  font-weight: bold;
  background-color: rgba(26, 95, 156, 0.3);
}

.date_selector_div {
  padding-bottom: 10px;
}

.flex {
  display: flex;
}

.flex .vdp-datepicker:not(:first-child) {
  margin-left: 10px;
}
</style>

<script>

import api from '@/api'
import PulseLoader from 'vue-spinner/src/PulseLoader.vue'
import Datepicker from 'vuejs-datepicker'
import {en, ru} from 'vuejs-datepicker/dist/locale'
import Multiselect from 'vue-multiselect'
import DateRangePicker from 'vue2-daterange-picker'
import moment from "moment";
import {Chart} from "highcharts-vue";
import LoadingButton from "@/components/buttons/LoadingButton";

export default {

  components: {
    PulseLoader,
    Datepicker,
    Multiselect,
    DateRangePicker,
    highcharts: Chart,
    LoadingButton,
  },
  data() {
    return {
      engadgedUsers: [],
      totalStat: {},
      totalStatData: {},
      statData: null,
      statManagers: [],
      managers: {},
      managersStat: null,
      en: en,
      ru: ru,
      color: '#5BBFDE',
      loading: null,
      orders: {},
      orders_summ: {},
      date_from: null,
      date_to: null,
      allProjects: [],
      selected_agent: null,
      selected_projects: null,
      AgentsOptions: [],
      AgentNames: [],
      list_of_agents: [],
      startDate: '',
      dateRange: {
        startDate: moment().startOf('isoWeek'),
        endDate: moment().endOf('isoWeek'),
      },
      date_locale: {
        firstDay: 1,
        format: 'DD-MM-YYYY',
        applyLabel: 'Выбрать',
        cancelLabel: 'Отмена',
      },
      ranges: { //default value for ranges object (if you set this to false ranges will no be rendered)
        'Текущая неделя': [moment().startOf('isoWeek'), moment().endOf('isoWeek')],
        'Прошлая неделя': [moment().subtract(1, 'isoWeek').startOf('isoWeek'), moment().subtract(1, 'isoWeek').endOf('isoWeek')],
        'Текущий месяц': [moment().startOf('month'), moment().endOf('month')],
        'Прошлый месяц': [moment().subtract(1, 'month').startOf('month'), moment().subtract(1, 'month').endOf('month')]
      },
      siteOrderChartData: {},
      manualOrderChartData: {},
      rejectedByRunners: {},
      defaultChartOption: {
        chart: {
          height: 200,
          // width: 1000,
          scrollablePlotArea: {
            // minWidth: 600,
            scrollPositionX: 1
          },
          // type: 'spline'
        },
        tooltip: {
          shared: true,
          crosshairs: true,
          // headerFormat: '<b>{series.name}</b><br>',
          // pointFormat: '{point} m'
        },
        legend: {
          layout: 'vertical',
          align: 'right',
          verticalAlign: 'middle'
        },
        xAxis: {
          categories: [],
          labels: {
            //   // enabled: false
            //   padding: 2,
            formatter: function () {
              var label = this.axis.defaultLabelFormatter.call(this);
              var date_arr = label.split('.');
              return date_arr[0] + '.' + date_arr[1];
            }
          },
        },
        minorTickInterval: 2,
        max: 5,
        plotOptions: {},
      },
    }
  },
  computed: {
    $AllProjects() {
      const sites = this.$store.getters["platform/projects"].reduce(
        (acc, p) => {
          acc[p.id] = {...p};
          return acc;
        },
        {}
      );
      return sites;
    },
  },
  created() {
    this.allProjects.push({id: 0, name: 'Все проекты'})
    Object.keys(this.$AllProjects).map((p) => {
      if (this.$AllProjects[p].id) {
        this.allProjects.push({id: this.$AllProjects[p].id, name: this.$AllProjects[p].name});
      }
    })
    this.getAgentsList()
  },
  methods: {
    getSorted(records, field) {
      return _.orderBy(records, field);
    },
    countTotal(record, status = null) {
      let total = 0
      Object.keys(record).map(function (key) {
        if (status == 0 || status === null)
          total += (record[key][0] == undefined) ? 0 : record[key][0]
        if (status == 9999 || status === null)
          total += (record[key][9999] == undefined) ? 0 : record[key][9999]
      })
      return total
    },
    async managersStats() {
      this.loading = true;
      this.statData = null;
      const {data} = await api.post('/new/orders/statistics', {
        dateRange: this.dateRange,
      })
      if (data.success) {
        this.engadgedUsers = data.usersRecords;
        this.managersStat = Object.keys(data.stat).reduce((acc, t) => {
          Object.keys(data.stat[t]).forEach((mId) => {
            if (!acc[mId]) acc[mId] = {
              closed: {
                orders: 0,
                sum: 0,
                bill: 0,
                percent: 0
              },
              rejected_m: {
                orders: 0,
                sum: 0,
                bill: 0,
                percent: 0
              },
              rejected_r: {
                orders: 0,
                sum: 0,
                bill: 0,
                percent: 0
              },
            };
            Object.keys(data.stat[t][mId]).forEach((k) => {
              acc[mId][k].orders += (data.stat[t][mId][k].orders || 0);
              acc[mId][k].sum += (data.stat[t][mId][k].sum || 0);
              acc[mId][k].bill = (acc[mId][k].bill + Math.round(acc[mId][k].sum / (acc[mId][k].orders || 1))) / (acc[mId][k].bill ? 2 : 1);
            })
          })
          return acc;
        }, {});
        const totalStat = {
          closed: {total: 0, percent: 0, sum: 0},
          rejected_m: {total: 0, percent: 0, sum: 0},
          rejected_r: {total: 0, percent: 0, sum: 0},
        };
        Object.keys(this.managersStat).forEach((mId) => {
          const totalOrders = Object.values(this.managersStat[mId]).reduce((acc, d) => acc + (typeof d === 'object' && d.orders || 0), 0);
          Object.keys(this.managersStat[mId]).forEach((t) => {
            totalStat[t].total += this.managersStat[mId][t].orders;
            totalStat[t].sum += this.managersStat[mId][t].sum;
            this.managersStat[mId][t].percent = Math.round(this.managersStat[mId][t].orders * 100 / (totalOrders || 1));
          })
        })
        const grandTotalOrders = Object.values(totalStat).reduce((acc, i) => acc + i.total, 0);
        Object.keys(totalStat).forEach((k) => {
          totalStat[k].percent = Math.round(totalStat[k].total * 100 / (grandTotalOrders || 1));
        })
        this.totalStat = totalStat;
        Object.keys(this.managersStat).forEach((mId) => {
          const total = Object.values(this.managersStat[mId]).reduce((acc, r) => {
            acc.orders += r.orders;
            acc.sum += r.sum;
            return acc;
          }, {orders: 0, sum: 0})
          this.managersStat[mId].total = {...total, bill: Math.round(total.sum / (total.orders || 1))}
        })
        // Object.keys(userNames).forEach((id) => {
        //   this.managersStat[id].managerName = userNames[id];
        // })

      } else {
        toastr['warning'](data.message || 'Ошибка');
      }
      this.loading = false;
    },
    requestAnalitics: async function (e) {
      e.preventDefault()
      if (!this.selected_projects || !this.selected_projects.length || this.loading) return;
      this.loading = true;
      this.orders = {};
      this.managersStat = null;
      try {
        const {data} = await api.store('/getAgentAnalitics', {
          dateRange: this.dateRange,
          selected_agent: this.selected_agent,
          selected_projects: this.selected_projects,
        })
        if (data.success) {
          const step = 1;
          this.siteOrderChartData = {...this.defaultChartOption};
          this.manualOrderChartData = {...this.defaultChartOption};
          this.rejectedByRunners = {...this.defaultChartOption};

          this.siteOrderChartData.title = {
            text: 'Заявки с сайта'
          };
          this.siteOrderChartData.series = [
            {
              name: 'Поступившие',
              color: '#6cb5f9'
            },
            {
              name: 'Обработанные',
              color: '#12fa0c'
            },
            {
              name: 'Отказ',
              color: '#333'
            }
          ];
          this.siteOrderChartData.yAxis = {
            title: {
              text: 'Заявки'
            },
          };
          this.siteOrderChartData.xAxis.categories = Object.keys(data.statData.site_incomes);
          this.siteOrderChartData.xAxis.labels.step = step;

          this.manualOrderChartData.title = {
            text: 'Ручные заявки'
          };
          this.manualOrderChartData.series = [
            // {
            //   name: 'Входящие звонки',
            //   color: '#ffe800'
            // },
            {
              name: 'Поступившие',
              color: '#6cb5f9'
            },
            {
              name: 'Обработанные',
              color: '#12fa0c'
            },
            {
              name: 'Отказ',
              color: '#333'
            }
          ];
          this.manualOrderChartData.xAxis.categories = Object.keys(data.statData.site_incomes);
          this.manualOrderChartData.xAxis.labels.step = step;

          this.rejectedByRunners.title = {
            text: 'Отмененные заявки'
          };
          this.rejectedByRunners.series = [
            {
              name: 'Обработанные',
              color: '#ffe800'
            },
            {
              name: 'Отказ у курьера',
              color: '#333'
            }
          ];
          this.rejectedByRunners.xAxis.categories = Object.keys(data.statData.all_done_by_manager);
          this.rejectedByRunners.xAxis.labels.step = step;


          this.siteOrderChartData.series[0].data = [];
          Object.keys(data.statData.site_incomes).forEach((key) => {
            this.siteOrderChartData.series[0].data.push(data.statData.site_incomes[key]);
          });
          this.siteOrderChartData.series[1].data = [];
          Object.keys(data.statData.site_incomes_done_by_manager).forEach((key) => {
            this.siteOrderChartData.series[1].data.push(data.statData.site_incomes_done_by_manager[key]);
          });
          this.siteOrderChartData.series[2].data = [];
          Object.keys(data.statData.site_incomes_rejected_by_manager).forEach((key) => {
            this.siteOrderChartData.series[2].data.push(data.statData.site_incomes_rejected_by_manager[key]);
          });

          // this.manualOrderChartData.series[0].data = [];
          // Object.keys(data.statData.income_phone_calls).forEach((key) => {
          //   this.manualOrderChartData.series[0].data.push(data.statData.income_phone_calls[key]);
          // });
          this.manualOrderChartData.series[0].data = [];
          Object.keys(data.statData.manual).forEach((key) => {
            this.manualOrderChartData.series[0].data.push(data.statData.manual[key]);
          });
          this.manualOrderChartData.series[1].data = [];
          Object.keys(data.statData.manual_done_by_manager).forEach((key) => {
            this.manualOrderChartData.series[1].data.push(data.statData.manual_done_by_manager[key]);
          });
          this.manualOrderChartData.series[2].data = [];
          Object.keys(data.statData.manual_rejected_by_manager).forEach((key) => {
            this.manualOrderChartData.series[2].data.push(data.statData.manual_rejected_by_manager[key]);
          });

          this.rejectedByRunners.series[0].data = [];
          Object.keys(data.statData.all_done_by_manager).forEach((key) => {
            this.rejectedByRunners.series[0].data.push(data.statData.all_done_by_manager[key]);
          });
          this.rejectedByRunners.series[1].data = [];
          Object.keys(data.statData.rejected_by_runner).forEach((key) => {
            this.rejectedByRunners.series[1].data.push(data.statData.rejected_by_runner[key]);
          });

          this.statData = data.statData;
          this.totalStatData = {
            site: {
              totalOrders: Object.values(data.statData.site_incomes).reduce((acc, v) => acc + v, 0),
              released: Object.values(data.statData.site_incomes_done_by_manager).reduce((acc, v) => acc + v, 0),
              rejected: Object.values(data.statData.site_incomes_rejected_by_manager).reduce((acc, v) => acc + v, 0),
            },
            manual: {
              // phoneCalls: Object.values(data.statData.income_phone_calls).reduce((acc, v) => acc + v, 0),
              totalOrders: Object.values(data.statData.manual).reduce((acc, v) => acc + v, 0),
              released: Object.values(data.statData.manual_done_by_manager).reduce((acc, v) => acc + v, 0),
              rejected: Object.values(data.statData.manual_rejected_by_manager).reduce((acc, v) => acc + v, 0),
            },
            rejected_by_runner: Object.values(data.statData.rejected_by_runner).reduce((acc, v) => acc + v, 0),
          }
        }
      } catch (e) {
        this.statData = null;
        console.log(e);
      }
      this.loading = false;

    },
    async getAgentsList() {
      const {data} = await api.index('/getAgentsList')
      const managers = {46: {name: 'Контролер'}};
      if (data.success) {
        let list = [];
        data.agents.forEach((a) => {
          if (!a.details || !a.details[0]) return;
          let projects = '(';
          a.details[0].details.forEach((d) => {
            // projects += ' ' + this.$AllProjects[d.project_id].name;
          })
          projects += ')';
          list.push({
            ...a,
            // name: a.name + ' ' + projects
            name: a.name
          })
          managers[a.id] = {...a}
        })
        this.managers = managers;
        this.AgentsOptions = list;
      }
    }
  }
}

</script>

<style scoped>
.alert p span {
  margin-right: 10px;
}

.rangePicker {
  min-width: 210px;
}

table.table td {
  padding-left: 5px;
}

.block_1 {
  background-color: #e7ffe6;
}

.block_2 {
  background-color: #fff2d5;
}

.block_3 {
  background-color: #ffe6e6;
}
</style>

<style>
.rangePicker .form-control.reportrange-text {
  height: 43px;
}

.rangePicker .form-control.reportrange-text span {
  vertical-align: sub;
}

</style>
